import React from 'react';
import { StickyHeader } from '../components/StickyHeader';
import { PurchaseNotification } from '../components/PurchaseNotification';
import { TestimonialCard } from '../components/TestimonialCard';
import { CountdownTimer } from '../components/CountdownTimer';
import { CheckCircle, AlertTriangle, ArrowDown, BookOpen, Leaf, Droplets, Clock } from 'lucide-react';
const CHECKOUT_URL = 'https://checkout.rosetadigital.com/cart/46081658093721:1';
const TESTIMONIALS = [{
  name: 'Carolina M.',
  age: '34',
  location: 'Buenos Aires',
  content: 'Siempre mataba mis suculentas por regarlas de más. Con este manual entendí exactamente cuándo hacerlo. ¡Ya logré multiplicar mi primera Echeveria!',
  imageIndex: 1
}, {
  name: 'Mariana R.',
  age: '29',
  location: 'Córdoba',
  content: 'Pensé que no tenía mano verde, pero solo me faltaba la información correcta. La guía de sustratos me cambió la vida, ahora mis cactus crecen hermosos.',
  imageIndex: 2
}, {
  name: 'Silvina G.',
  age: '42',
  location: 'Rosario',
  content: 'Lo compré un domingo y el lunes ya estaba preparando mis primeros esquejes. Es súper visual y fácil de seguir. Recomendadísimo.',
  imageIndex: 3
}, {
  name: 'Florencia T.',
  age: '27',
  location: 'Mendoza',
  content: "Me encantó la sección de 'qué hacer si algo sale mal'. Pude salvar una planta que creí perdida. Vale cada peso.",
  imageIndex: 4
}, {
  name: 'Laura B.',
  age: '38',
  location: 'La Plata',
  content: 'Directo al grano, sin vueltas. Las fotos ayudan un montón para darte cuenta si lo estás haciendo bien. Ya tengo mi balcón lleno de hijitos.',
  imageIndex: 5
}];
export function SalesPage() {
  const scrollToPurchase = () => {
    const element = document.getElementById('comprar');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <div className="min-h-screen bg-[#f5f1e8] font-sans text-gray-800 selection:bg-[#c4704f] selection:text-white pb-20" data-id="element-35">
      <StickyHeader data-id="element-36" />
      <PurchaseNotification data-id="element-37" />

      {/* Hero Section */}
      <header className="pt-24 pb-8 px-4 md:px-6 lg:px-8 max-w-5xl mx-auto" data-id="element-38">
        {/* Hook Poderoso */}
        <div className="text-center mb-8" data-id="element-39">
          <div className="inline-block bg-red-100 text-red-800 px-4 py-1 rounded-full text-sm font-bold mb-6 border border-red-200 animate-pulse" data-id="element-40">
            ⚠️ DEJÁ DE MATAR TUS PLANTAS
          </div>

          <h1 className="text-3xl md:text-5xl lg:text-6xl font-extrabold text-[#2d5016] leading-tight mb-6 tracking-tight" data-id="element-41">
            MANUAL PARA MULTIPLICAR
            <br data-id="element-42" />
            SUCULENTAS Y CACTUS
          </h1>

          <p className="text-xl md:text-2xl text-gray-700 mb-4 max-w-3xl mx-auto leading-relaxed font-medium" data-id="element-43">
            La guía paso a paso para que{' '}
            <span className="text-[#c4704f] font-bold" data-id="element-44">
              dejes de matar plantas
            </span>{' '}
            y empieces a multiplicarlas sin gastar más plata ni volverte loco
          </p>

          <p className="text-base md:text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-45">
            Aunque nunca hayas tenido suerte con las suculentas, aunque se te
            hayan muerto todas, y aunque pienses que "no tenés mano verde"
          </p>
        </div>

        {/* Imagen del Producto Principal */}
        <div className="flex justify-center mb-8" data-id="element-46">
          <div onClick={scrollToPurchase} className="relative cursor-pointer transform transition hover:scale-105 duration-300 max-w-sm" data-id="element-47">
            <div className="absolute -inset-4 bg-[#c4704f]/20 rounded-full blur-2xl" data-id="element-48"></div>
            <img src="https://cdn.magicpatterns.com/uploads/epNisGwnZ2T7dDC5ku8hhX/ChatGPT_Image_12_ene_2026,_19_39_21.png" alt="Manual Completo para Multiplicar Suculentas y Cactus" className="relative rounded-lg shadow-2xl w-full object-cover" data-id="element-49" />
          </div>
        </div>

        {/* CTA Principal */}
        <div className="text-center" data-id="element-50">
          <button onClick={scrollToPurchase} className="bg-[#c4704f] hover:bg-[#a85d3f] text-white text-lg md:text-xl font-bold py-4 px-8 rounded-full shadow-lg transform transition hover:scale-105 inline-flex items-center justify-center gap-2 mb-3" data-id="element-51">
            <span data-id="element-52">✅ DESCARGAR AHORA Y EMPEZAR HOY</span>
            <ArrowDown className="w-5 h-5" data-id="element-53" />
          </button>
          <p className="text-sm text-gray-600 font-medium" data-id="element-54">
            🔥 Acceso inmediato • Solo quedan 7 copias disponibles hoy
          </p>
        </div>
      </header>

      {/* Problem Section */}
      <section className="py-16 px-4 bg-white" data-id="element-55">
        <div className="max-w-3xl mx-auto" data-id="element-56">
          <div className="prose prose-lg prose-stone mx-auto" data-id="element-57">
            <p className="font-medium text-lg" data-id="element-58">
              No es falta de mano verde. No es mala suerte. Y no sos "malo" con
              las plantas.
            </p>
            <p data-id="element-59">El problema es que nadie te explicó el proceso real.</p>

            <div className="bg-[#f9f9f7] p-6 rounded-xl border-l-4 border-[#2d5016] my-8" data-id="element-60">
              <h3 className="text-[#2d5016] font-bold text-xl mt-0" data-id="element-61">
                Si esto te pasa, no estás solo…
              </h3>
              <p className="mb-0" data-id="element-62">
                Vivís en ciudad o departamento, te encantan las plantas… pero no
                te considerás experto.
              </p>
            </div>

            <p data-id="element-63">Compraste suculentas y cactus porque:</p>
            <ul className="grid grid-cols-1 md:grid-cols-3 gap-4 not-prose my-6" data-id="element-64">
              <li className="flex items-center gap-2 bg-green-50 p-3 rounded-lg text-green-800 font-medium" data-id="element-65">
                <CheckCircle className="w-5 h-5 flex-shrink-0" data-id="element-66" /> son lindas
              </li>
              <li className="flex items-center gap-2 bg-green-50 p-3 rounded-lg text-green-800 font-medium" data-id="element-67">
                <CheckCircle className="w-5 h-5 flex-shrink-0" data-id="element-68" /> son baratas
              </li>
              <li className="flex items-center gap-2 bg-green-50 p-3 rounded-lg text-green-800 font-medium" data-id="element-69">
                <CheckCircle className="w-5 h-5 flex-shrink-0" data-id="element-70" /> "dicen que son
                fáciles"
              </li>
            </ul>

            <p className="text-xl font-bold text-gray-900" data-id="element-71">
              Y aun así… se te murieron. Algunas. Varias. Demasiadas.
            </p>

            <p data-id="element-72">
              Y te queda esa mezcla rara de bronca y vergüenza:{' '}
              <em data-id="element-73">"¿Cómo puede ser que algo tan simple no me salga?"</em>
            </p>
          </div>
        </div>
      </section>

      {/* Agitation Section */}
      <section className="py-16 px-4 bg-[#2d5016] text-white" data-id="element-74">
        <div className="max-w-3xl mx-auto" data-id="element-75">
          <h2 className="text-3xl font-bold mb-8 text-center text-[#e8f5e9]" data-id="element-76">
            El dolor real (y por qué cansa tanto)
          </h2>

          <div className="grid md:grid-cols-2 gap-8 items-center" data-id="element-77">
            <div data-id="element-78">
              <p className="text-lg mb-4 opacity-90" data-id="element-79">
                El problema no es solo la planta. Es la confusión. Es el
                desgaste mental. Porque te cruzás con consejos contradictorios
                todo el tiempo:
              </p>

              <div className="space-y-3 mb-6" data-id="element-80">
                <div className="bg-white/10 p-3 rounded-lg backdrop-blur-sm" data-id="element-81">
                  "Regá poco" vs "No, regá más"
                </div>
                <div className="bg-white/10 p-3 rounded-lg backdrop-blur-sm" data-id="element-82">
                  "Con sol" vs "Sin sol"
                </div>
                <div className="bg-white/10 p-3 rounded-lg backdrop-blur-sm" data-id="element-83">
                  "Cada 15 días" vs "Cuando esté seca"
                </div>
              </div>
            </div>

            <div className="bg-white/5 p-6 rounded-xl border border-white/10" data-id="element-84">
              <p className="font-bold text-xl mb-4 text-red-200" data-id="element-85">Resultado:</p>
              <ul className="space-y-3" data-id="element-86">
                <li className="flex items-start gap-3" data-id="element-87">
                  <AlertTriangle className="w-5 h-5 text-red-300 flex-shrink-0 mt-1" data-id="element-88" />
                  <span data-id="element-89">
                    O no hacés nada por miedo… o hacés de todo y la terminás
                    matando igual.
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-90">
                  <AlertTriangle className="w-5 h-5 text-red-300 flex-shrink-0 mt-1" data-id="element-91" />
                  <span data-id="element-92">Macetas vacías</span>
                </li>
                <li className="flex items-start gap-3" data-id="element-93">
                  <AlertTriangle className="w-5 h-5 text-red-300 flex-shrink-0 mt-1" data-id="element-94" />
                  <span data-id="element-95">Plantas que no crecen</span>
                </li>
                <li className="flex items-start gap-3" data-id="element-96">
                  <AlertTriangle className="w-5 h-5 text-red-300 flex-shrink-0 mt-1" data-id="element-97" />
                  <span data-id="element-98">
                    Plata tirada y la sensación de "esto no es para mí"
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Context / Why Now */}
      <section className="py-16 px-4 bg-[#f5f1e8]" data-id="element-99">
        <div className="max-w-3xl mx-auto text-center" data-id="element-100">
          <h2 className="text-3xl font-bold text-[#2d5016] mb-6" data-id="element-101">
            El momento perfecto para empezar
          </h2>
          <p className="text-lg text-gray-700 mb-8 leading-relaxed" data-id="element-102">
            Estamos en ese momento donde querés ordenar tu casa, tu energía, tu
            rutina. Fin de año / arranque de ciclo / ganas de empezar algo lindo
            y simple… pero sin sumar estrés.
          </p>
          <p className="text-lg text-gray-700 mb-8 font-medium" data-id="element-103">
            Y las plantas deberían ser eso: un mimo, un refugio, un rincón vivo.
            No otra cosa que te frustra.
          </p>

          <div className="bg-white p-6 rounded-xl shadow-sm border border-[#c4704f]/20 inline-block" data-id="element-104">
            <p className="text-[#c4704f] font-bold text-lg mb-4" data-id="element-105">
              Por eso, si venís de fallar con suculentas o cactus… HOY es el día
              ideal para hacerlo bien, con un paso a paso claro.
            </p>
            <div className="flex flex-col md:flex-row items-center justify-center gap-4 text-sm font-bold text-gray-500" data-id="element-106">
              <span className="flex items-center gap-2" data-id="element-107">
                <AlertTriangle className="w-4 h-4 text-orange-500" data-id="element-108" />
                Solo quedan 7 copias disponibles hoy
              </span>
              <span className="flex items-center gap-2" data-id="element-109">
                <Clock className="w-4 h-4 text-orange-500" data-id="element-110" />
                Oferta activa hasta que el contador llegue a 0
              </span>
            </div>
          </div>

          <div className="mt-8" data-id="element-111">
            <button onClick={scrollToPurchase} className="text-[#2d5016] font-bold underline hover:text-[#c4704f] transition-colors" data-id="element-112">
              ✅ QUIERO DESCARGAR AHORA
            </button>
          </div>
        </div>
      </section>

      {/* The Truth Section */}
      <section className="py-16 px-4 bg-white" data-id="element-113">
        <div className="max-w-3xl mx-auto" data-id="element-114">
          <h2 className="text-3xl font-bold text-center mb-10" data-id="element-115">
            La verdad que nadie te dice (y que cambia todo)
          </h2>

          <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-116">
            <div data-id="element-117">
              <p className="text-lg mb-4" data-id="element-118">
                Las suculentas y los cactus no mueren por falta de cuidado.
                Mueren por algo más común:
              </p>
              <p className="text-2xl font-bold text-[#c4704f] mb-6" data-id="element-119">
                👉 Exceso de ayuda.
              </p>

              <ul className="space-y-2 text-gray-600 mb-6" data-id="element-120">
                <li className="flex items-center gap-2" data-id="element-121">
                  ❌ Las regamos "por las dudas"
                </li>
                <li className="flex items-center gap-2" data-id="element-122">
                  ❌ Las plantamos antes de tiempo
                </li>
                <li className="flex items-center gap-2" data-id="element-123">
                  ❌ Las tocamos para ver si van bien
                </li>
                <li className="flex items-center gap-2" data-id="element-124">
                  ❌ Intervenimos cuando no toca
                </li>
              </ul>

              <p className="font-medium" data-id="element-125">Y así se pudren… o se secan.</p>
            </div>

            <div className="bg-green-50 p-8 rounded-2xl border border-green-100" data-id="element-126">
              <h3 className="text-xl font-bold text-[#2d5016] mb-4" data-id="element-127">
                La solución no es "hacer más".
              </h3>
              <p className="text-lg leading-relaxed" data-id="element-128">
                ✅ La solución es aprender cuándo intervenir y sobre todo…{' '}
                <span className="font-bold underline decoration-[#c4704f] decoration-2" data-id="element-129">
                  cuándo NO hacer nada.
                </span>
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Product Presentation */}
      <section className="py-20 px-4 bg-[#2d5016] text-white relative overflow-hidden" data-id="element-130">
        <div className="absolute top-0 left-0 w-full h-full opacity-10 pointer-events-none" data-id="element-131">
          <Leaf className="absolute top-10 left-10 w-64 h-64" data-id="element-132" />
          <Droplets className="absolute bottom-10 right-10 w-48 h-48" data-id="element-133" />
        </div>

        <div className="max-w-5xl mx-auto relative z-10" data-id="element-134">
          <div className="text-center mb-12" data-id="element-135">
            <h2 className="text-3xl md:text-5xl font-bold mb-6" data-id="element-136">
              MANUAL PARA MULTIPLICAR SUCULENTAS Y CACTUS SIN EXPERIENCIA
            </h2>
            <p className="text-xl text-green-100 max-w-2xl mx-auto" data-id="element-137">
              Una guía práctica y visual para lograr resultados visibles sin
              gastar dinero ni comprar más plantas.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-138">
            <div className="order-2 md:order-1" data-id="element-139">
              <div className="bg-white/10 backdrop-blur-sm p-8 rounded-2xl border border-white/20" data-id="element-140">
                <h3 className="text-2xl font-bold mb-6" data-id="element-141">Vas a aprender a:</h3>
                <ul className="space-y-4" data-id="element-142">
                  <li className="flex items-start gap-3" data-id="element-143">
                    <CheckCircle className="w-6 h-6 text-[#c4704f] flex-shrink-0" data-id="element-144" />
                    <span data-id="element-145">
                      Multiplicar suculentas desde hojas, gajos o hijuelos
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-146">
                    <CheckCircle className="w-6 h-6 text-[#c4704f] flex-shrink-0" data-id="element-147" />
                    <span data-id="element-148">Multiplicar cactus sin que se pudran</span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-149">
                    <CheckCircle className="w-6 h-6 text-[#c4704f] flex-shrink-0" data-id="element-150" />
                    <span data-id="element-151">Saber exactamente qué hacer en cada etapa</span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-152">
                    <CheckCircle className="w-6 h-6 text-[#c4704f] flex-shrink-0" data-id="element-153" />
                    <span data-id="element-154">Evitar los errores que las matan</span>
                  </li>
                </ul>

                <div className="mt-8 pt-6 border-t border-white/20" data-id="element-155">
                  <p className="font-medium text-green-100" data-id="element-156">
                    Sin productos raros. Sin tecnicismos. Sin experiencia
                    previa.
                    <br data-id="element-157" />
                    <span className="text-white font-bold" data-id="element-158">
                      Solo un proceso claro, para principiantes reales.
                    </span>
                  </p>
                </div>
              </div>

              <div className="mt-8 text-center md:text-left" data-id="element-159">
                <button onClick={scrollToPurchase} className="bg-[#c4704f] hover:bg-[#a85d3f] text-white font-bold py-3 px-8 rounded-full shadow-lg transition-colors inline-flex items-center gap-2" data-id="element-160">
                  ✅ DESCARGAR AHORA
                </button>
              </div>
            </div>

            <div className="order-1 md:order-2 flex justify-center" data-id="element-161">
              <div onClick={scrollToPurchase} className="relative cursor-pointer transform transition hover:scale-105 duration-300" data-id="element-162">
                <div className="absolute -inset-4 bg-[#c4704f]/30 rounded-full blur-xl animate-pulse" data-id="element-163"></div>
                <img src="https://cdn.magicpatterns.com/uploads/epNisGwnZ2T7dDC5ku8hhX/ChatGPT_Image_12_ene_2026,_19_39_21.png" alt="Manual Completo para Multiplicar Suculentas y Cactus" className="relative rounded-lg shadow-2xl w-full max-w-md mx-auto object-cover" data-id="element-164" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="py-16 px-4 bg-[#f5f1e8]" data-id="element-165">
        <div className="max-w-4xl mx-auto" data-id="element-166">
          <div className="text-center mb-12" data-id="element-167">
            <h2 className="text-3xl font-bold text-[#2d5016]" data-id="element-168">
              Lo que cambia en tu vida
            </h2>
          </div>

          <div className="grid md:grid-cols-2 gap-8" data-id="element-169">
            <div className="bg-white p-8 rounded-xl shadow-sm" data-id="element-170">
              <h3 className="text-xl font-bold mb-4 text-gray-800" data-id="element-171">
                A partir de hoy, en vez de adivinar, vas a saber:
              </h3>
              <ul className="space-y-3 text-gray-600" data-id="element-172">
                <li className="flex items-center gap-2" data-id="element-173">
                  <BookOpen className="w-5 h-5 text-[#c4704f]" data-id="element-174" /> si esa hoja
                  sirve o no
                </li>
                <li className="flex items-center gap-2" data-id="element-175">
                  <BookOpen className="w-5 h-5 text-[#c4704f]" data-id="element-176" /> cuándo ponerla
                  y cuándo dejarla quieta
                </li>
                <li className="flex items-center gap-2" data-id="element-177">
                  <BookOpen className="w-5 h-5 text-[#c4704f]" data-id="element-178" /> cuándo regar y
                  cuándo NO regar
                </li>
                <li className="flex items-center gap-2" data-id="element-179">
                  <BookOpen className="w-5 h-5 text-[#c4704f]" data-id="element-180" /> qué es normal
                  y qué es señal de problema
                </li>
                <li className="flex items-center gap-2" data-id="element-181">
                  <BookOpen className="w-5 h-5 text-[#c4704f]" data-id="element-182" /> cómo pasar de
                  hoja → raíces → brote → planta nueva
                </li>
              </ul>
            </div>

            <div className="bg-[#2d5016]/10 p-8 rounded-xl flex flex-col justify-center items-center text-center" data-id="element-183">
              <h3 className="text-xl font-bold mb-4 text-[#2d5016]" data-id="element-184">
                Y lo mejor:
              </h3>
              <p className="text-2xl font-serif italic text-[#c4704f] mb-6" data-id="element-185">
                "Vas a poder decir con orgullo: Esta la multipliqué yo."
              </p>
            </div>
          </div>

          <div className="mt-12 bg-white p-6 rounded-xl border-l-4 border-[#c4704f]" data-id="element-186">
            <h3 className="font-bold text-lg mb-2" data-id="element-187">
              Por qué esto funciona cuando lo demás no
            </h3>
            <p className="text-gray-600" data-id="element-188">
              TikTok y YouTube te muestran el resultado, no el proceso. Los
              blogs te marean. Y los consejos sueltos te hacen fallar. Este
              manual está hecho para que tengas:{' '}
              <span className="font-bold" data-id="element-189">
                pasos claros, tiempos reales y sobre todo: qué NO hacer para no
                arruinarla.
              </span>
            </p>
          </div>
        </div>
      </section>

      {/* Bonuses Section */}
      <section className="py-16 px-4 bg-white" data-id="element-190">
        <div className="max-w-6xl mx-auto" data-id="element-191">
          <div className="text-center mb-12" data-id="element-192">
            <span className="bg-[#c4704f] text-white px-4 py-1 rounded-full font-bold text-sm uppercase tracking-wider mb-4 inline-block" data-id="element-193">
              Regalos Exclusivos
            </span>
            <h2 className="text-3xl md:text-4xl font-bold text-[#2d5016]" data-id="element-194">
              Llevate estos 3 Bonos{' '}
              <span className="underline decoration-[#c4704f]" data-id="element-195">GRATIS HOY</span>
            </h2>
          </div>

          <div className="grid md:grid-cols-3 gap-8" data-id="element-196">
            {/* Bonus 1 */}
            <div onClick={scrollToPurchase} className="group cursor-pointer" data-id="element-197">
              <div className="bg-[#f5f1e8] rounded-xl overflow-hidden shadow-lg transition-transform group-hover:-translate-y-2 duration-300 h-full flex flex-col" data-id="element-198">
                <div className="relative aspect-[3/4] overflow-hidden bg-gray-200" data-id="element-199">
                  <img src="https://cdn.magicpatterns.com/uploads/aUdyUMPxaQuuMDrt8DkSh7/20260112_2009_Image_Generation_simple_compose_01ket7fk3rexgv6txs4qen7q3e.png" alt="Bono 1: Tipos de Sustratos" className="w-full h-full object-cover" data-id="element-200" />
                  <div className="absolute top-4 right-4 bg-[#2d5016] text-white text-xs font-bold px-3 py-1 rounded-full" data-id="element-201">
                    BONO #1
                  </div>
                </div>
                <div className="p-6 flex-grow" data-id="element-202">
                  <h3 className="font-bold text-xl mb-2 text-[#2d5016]" data-id="element-203">
                    Tipos de Sustratos que Sí Funcionan
                  </h3>
                  <p className="text-sm text-gray-600" data-id="element-204">
                    Cómo elegir y preparar el sustrato correcto sin complicarte.
                  </p>
                  <p className="text-[#c4704f] font-bold mt-4 text-sm" data-id="element-205">
                    Valor: $5.000 (GRATIS HOY)
                  </p>
                </div>
              </div>
            </div>

            {/* Bonus 2 */}
            <div onClick={scrollToPurchase} className="group cursor-pointer" data-id="element-206">
              <div className="bg-[#f5f1e8] rounded-xl overflow-hidden shadow-lg transition-transform group-hover:-translate-y-2 duration-300 h-full flex flex-col" data-id="element-207">
                <div className="relative aspect-[3/4] overflow-hidden bg-gray-200" data-id="element-208">
                  <img src="https://cdn.magicpatterns.com/uploads/4ZZCvT134RHfyDeJMUG33a/20260112_2001_Image_Generation_simple_compose_01ket71zq7f73b7k64bat1gfr8.png" alt="Bono 2: Los Errores Más Comunes" className="w-full h-full object-cover" data-id="element-209" />
                  <div className="absolute top-4 right-4 bg-[#2d5016] text-white text-xs font-bold px-3 py-1 rounded-full" data-id="element-210">
                    BONO #2
                  </div>
                </div>
                <div className="p-6 flex-grow" data-id="element-211">
                  <h3 className="font-bold text-xl mb-2 text-[#2d5016]" data-id="element-212">
                    Los Errores Más Comunes
                  </h3>
                  <p className="text-sm text-gray-600" data-id="element-213">
                    Y cómo evitarlos antes de que sea tarde.
                  </p>
                  <p className="text-[#c4704f] font-bold mt-4 text-sm" data-id="element-214">
                    Valor: $5.000 (GRATIS HOY)
                  </p>
                </div>
              </div>
            </div>

            {/* Bonus 3 */}
            <div onClick={scrollToPurchase} className="group cursor-pointer" data-id="element-215">
              <div className="bg-[#f5f1e8] rounded-xl overflow-hidden shadow-lg transition-transform group-hover:-translate-y-2 duration-300 h-full flex flex-col" data-id="element-216">
                <div className="relative aspect-[3/4] overflow-hidden bg-gray-200" data-id="element-217">
                  <img src="https://cdn.magicpatterns.com/uploads/cCophWTr7yXRtPdciePMcz/20260112_2006_Image_Generation_remix_01ket7a6fwfdg9tdnp158m12gt.png" alt="Bono 3: Qué Hacer Si Algo Sale Mal" className="w-full h-full object-cover" data-id="element-218" />
                  <div className="absolute top-4 right-4 bg-[#2d5016] text-white text-xs font-bold px-3 py-1 rounded-full" data-id="element-219">
                    BONO #3
                  </div>
                </div>
                <div className="p-6 flex-grow" data-id="element-220">
                  <h3 className="font-bold text-xl mb-2 text-[#2d5016]" data-id="element-221">
                    Qué Hacer Si Algo Sale Mal
                  </h3>
                  <p className="text-sm text-gray-600" data-id="element-222">
                    Soluciones rápidas para salvar tus suculentas y cactus.
                  </p>
                  <p className="text-[#c4704f] font-bold mt-4 text-sm" data-id="element-223">
                    Valor: $5.000 (GRATIS HOY)
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Scarcity Banner */}
      <div className="bg-red-50 border-y border-red-100 py-4 text-center" data-id="element-224">
        <div className="max-w-4xl mx-auto px-4 flex flex-col md:flex-row items-center justify-center gap-4 text-red-800 font-bold" data-id="element-225">
          <span className="flex items-center gap-2" data-id="element-226">
            <AlertTriangle className="w-5 h-5" data-id="element-227" />
            Solo quedan 7 copias disponibles hoy
          </span>
          <span className="hidden md:inline" data-id="element-228">|</span>
          <span className="flex items-center gap-2" data-id="element-229">
            <Clock className="w-5 h-5" data-id="element-230" />
            Tiempo restante:{' '}
            <CountdownTimer className="text-red-800" showIcon={false} data-id="element-231" />
          </span>
        </div>
      </div>

      {/* Purchase Section */}
      <section id="comprar" className="py-16 px-4 bg-[#f5f1e8]" data-id="element-232">
        <div className="max-w-3xl mx-auto bg-white rounded-2xl shadow-2xl overflow-hidden border border-[#2d5016]/10" data-id="element-233">
          <div className="bg-[#2d5016] p-6 text-center text-white" data-id="element-234">
            <h2 className="text-2xl md:text-3xl font-bold" data-id="element-235">
              Descargá el Manual Hoy
            </h2>
            <p className="opacity-90 mt-2" data-id="element-236">
              Acceso inmediato + guía completa para principiantes
            </p>
          </div>

          <div className="p-8 md:p-12 text-center" data-id="element-237">
            <div className="flex flex-col md:flex-row items-center justify-center gap-8 mb-10" data-id="element-238">
              <img src="https://cdn.magicpatterns.com/uploads/epNisGwnZ2T7dDC5ku8hhX/ChatGPT_Image_12_ene_2026,_19_39_21.png" alt="Manual Pack" className="w-48 shadow-lg rounded-lg transform -rotate-3 hover:rotate-0 transition-transform duration-500" data-id="element-239" />
              <div className="text-left" data-id="element-240">
                <div className="text-gray-500 line-through text-lg" data-id="element-241">
                  Precio Regular: $35.000
                </div>
                <div className="text-5xl font-extrabold text-[#2d5016] my-2" data-id="element-242">
                  $19.990
                </div>
                <div className="text-[#c4704f] font-bold text-sm uppercase tracking-wide" data-id="element-243">
                  Oferta por tiempo limitado
                </div>
              </div>
            </div>

            <div className="space-y-4 mb-8 text-left max-w-md mx-auto" data-id="element-244">
              <div className="flex items-center gap-3" data-id="element-245">
                <CheckCircle className="w-5 h-5 text-green-600 flex-shrink-0" data-id="element-246" />
                <span data-id="element-247">Manual Completo (PDF Digital)</span>
              </div>
              <div className="flex items-center gap-3" data-id="element-248">
                <CheckCircle className="w-5 h-5 text-green-600 flex-shrink-0" data-id="element-249" />
                <span data-id="element-250">Bono 1: Guía de Sustratos</span>
              </div>
              <div className="flex items-center gap-3" data-id="element-251">
                <CheckCircle className="w-5 h-5 text-green-600 flex-shrink-0" data-id="element-252" />
                <span data-id="element-253">Bono 2: Errores Comunes</span>
              </div>
              <div className="flex items-center gap-3" data-id="element-254">
                <CheckCircle className="w-5 h-5 text-green-600 flex-shrink-0" data-id="element-255" />
                <span data-id="element-256">Bono 3: Soluciones Rápidas</span>
              </div>
              <div className="flex items-center gap-3" data-id="element-257">
                <CheckCircle className="w-5 h-5 text-green-600 flex-shrink-0" data-id="element-258" />
                <span data-id="element-259">Acceso inmediato, te llega todo a tu email</span>
              </div>
            </div>

            <a href={CHECKOUT_URL} className="block w-full max-w-md mx-auto bg-[#2d5016] hover:bg-[#1e360f] text-white text-xl font-bold py-5 px-8 rounded-xl shadow-xl transform transition hover:scale-105 hover:shadow-2xl mb-4" data-id="element-260">
              ✅ DESCARGAR AHORA
            </a>

            <p className="text-xs text-gray-500 flex items-center justify-center gap-2" data-id="element-261">
              <span className="w-2 h-2 bg-green-500 rounded-full animate-pulse" data-id="element-262"></span>
              Pago seguro y encriptado
            </p>
          </div>

          <div className="bg-gray-50 p-4 text-center text-sm text-gray-600 border-t border-gray-100" data-id="element-263">
            Recordatorio: ⏳ Oferta activa hasta que el contador llegue a 0 | ⚠️
            Solo quedan 7 copias disponibles hoy
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="py-16 px-4 bg-white" data-id="element-264">
        <div className="max-w-6xl mx-auto" data-id="element-265">
          <h2 className="text-3xl font-bold text-center mb-12 text-[#2d5016]" data-id="element-266">
            Lo que dicen quienes ya lo descargaron
          </h2>

          <div className="grid md:grid-cols-3 gap-6" data-id="element-267">
            {TESTIMONIALS.slice(0, 3).map((t, i) => <TestimonialCard key={i} {...t} data-id="element-268" />)}
          </div>
          <div className="grid md:grid-cols-2 gap-6 mt-6 max-w-4xl mx-auto" data-id="element-269">
            {TESTIMONIALS.slice(3, 5).map((t, i) => <TestimonialCard key={i + 3} {...t} data-id="element-270" />)}
          </div>
        </div>
      </section>

      {/* Final CTA */}
      <section className="py-20 px-4 bg-[#2d5016] text-white text-center" data-id="element-271">
        <div className="max-w-3xl mx-auto" data-id="element-272">
          <h2 className="text-3xl md:text-4xl font-bold mb-8" data-id="element-273">
            ¿Lista para tener suculentas que sí crecen?
          </h2>
          <p className="text-xl mb-10 opacity-90" data-id="element-274">
            No dejes pasar otra oportunidad de tener el jardín que querés.
          </p>

          <a href={CHECKOUT_URL} className="inline-block bg-[#c4704f] hover:bg-[#a85d3f] text-white text-xl font-bold py-5 px-10 rounded-full shadow-xl transform transition hover:scale-105" data-id="element-275">
            ✅ SÍ, QUIERO MULTIPLICAR MIS SUCULENTAS Y CACTUS
          </a>

          <div className="mt-8 flex items-center justify-center gap-2 text-sm opacity-75" data-id="element-276">
            <Clock className="w-4 h-4" data-id="element-277" />
            <span data-id="element-278">Oferta por tiempo limitado</span>
          </div>
        </div>
      </section>

      <footer className="bg-[#1a2e0d] text-white/40 py-8 text-center text-sm" data-id="element-279">
        <p data-id="element-280">© 2024 Manual de Suculentas. Todos los derechos reservados.</p>
      </footer>
    </div>;
}